import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=3f75656a&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f75656a",
  null
  
)

export default component.exports